import * as React from 'react';
import clsx from 'clsx';
import { useAnimation } from '../../hooks';
import { Base } from '../Base';
import { Backdrop, useOverlay, NewLayer as Layer, Overlay } from '../Helper';
import { DialogProvider } from './DialogContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "slideIn": "Dialog-slideIn_3y8NL",
  "slideOut": "Dialog-slideOut_1ORJI",
  "root": "Dialog-root_1QqSk",
  "dialog": "Dialog-dialog_2AYu1",
  "overlay": "Dialog-overlay_25afY",
  "scrollPaper": "Dialog-scrollPaper_29xLa",
  "scrollBody": "Dialog-scrollBody_JfAq5"
};
function DialogImpl({
  id,
  scroll,
  style,
  close,
  children
}) {
  const dialogRef = React.useRef(null);
  const {
    overlayProps
  } = useOverlay({
    onClose: close
  }, dialogRef);
  const identifier = React.useId();
  const labelId = typeof id === 'string' && id.length > 0 ? `${id}-label` : identifier ? `dialog-${identifier}-label` : undefined;
  return /*#__PURE__*/_jsx(Base, {
    innerRef: dialogRef,
    tagName: "article",
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": labelId,
    style: style,
    className: styles.dialog,
    margin: "small",
    ...overlayProps,
    children: /*#__PURE__*/_jsx(DialogProvider, {
      labelId: labelId,
      scroll: scroll,
      close: close,
      children: children
    })
  });
}
function Dialog({
  scroll = 'paper',
  open = false,
  id,
  children,
  style: styleProp,
  close
}) {
  const {
    render,
    onAnimationEnd
  } = useAnimation({
    visible: open
  });
  const rootClasses = clsx(styles.root, {
    [styles.scrollPaper]: scroll === 'paper',
    [styles.scrollBody]: scroll === 'body'
  });
  const style = {
    '--animation': open ? 'var(--animation-in)' : 'var(--animation-out)'
  };
  if (!render) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Layer, {
    children: [/*#__PURE__*/_jsx(Backdrop, {
      onAnimationEnd: onAnimationEnd,
      style: style
    }), /*#__PURE__*/_jsx(Base, {
      position: "fixed",
      className: rootClasses,
      children: /*#__PURE__*/_jsx(Overlay, {
        preventBodyScroll: true,
        className: styles.overlay,
        children: /*#__PURE__*/_jsx(DialogImpl, {
          id: id,
          scroll: scroll,
          close: close,
          style: {
            ...styleProp,
            ...style
          },
          children: children
        })
      })
    })]
  });
}
export { Dialog };